import ICoordinates, { NewCoordinates } from "../Coordinates";
import IDate, { NewDate } from "../Date";

interface IMainPlacement {
    ID?: number;
    placeID: number;
    place: string;
    startDate: IDate;
    endDate: IDate;
    munimentGenesisDate: IDate;
    munimentNumber: string;
    munimentIssuingAuthority: string;
    income: string;
    numberOfPeople: string;
    coordinates: ICoordinates;
}

export const NewMainPlacement: IMainPlacement = {
    placeID: 0,
    place: "",
    startDate: NewDate,
    endDate: NewDate,
    munimentGenesisDate: NewDate,
    munimentNumber: "",
    munimentIssuingAuthority: "",
    income: "",
    numberOfPeople: "",
    coordinates: NewCoordinates
};

export default IMainPlacement;
